import React ,{useState} from "react";
import { formatDateWithoutTime } from "../../utils/formateDate";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { months } from "../../utils/months";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useNavigate, useParams } from "react-router";
import { Modal, Table } from "react-bootstrap";
import { formatDate } from "../../utils/formateDate";


const EagleManager = ({ eagleData }) => {
  const { t } = useTranslation();
   const navigate = useNavigate();
const [showSupervisorModal, setShowSupervisorModal] = useState(false);

  const handleExpand = () => {
   navigate('/eagle-manager');
  };

    // Handle supervisor modal - changed to click instead of hover
  const handleSupervisorClick = () => {
    setShowSupervisorModal(true);
  };

  const closeSupervisorModal = () => {
    setShowSupervisorModal(false);
  };

  return (
    <div className="col-md-6">
      <div className="joinings_viewBox">
        <div className="joinings_viewBox_head">
          <h5>{t("EagleManager")}  ({eagleData?.summary?.periodRange}) </h5>
          <p style={{ textAlign: "right" }}>  <a className="btn btn-tree-act" onClick={handleExpand}>
                <i className="fa fa-expand"></i>
              </a></p>
        </div>

        <div className="teammbrs_cnt">
          {!eagleData ? (
            <div className="teammbrs_cnt_row">
              <div className="teammbrs_cnt_img">
                <Skeleton
                  width="45px"
                  height="45px"
                  circle
                  containerClassName="avatar-skeleton"
                  count={3}
                />
              </div>
              <div className="teammbrs_cnt_name_dtl">
                <div className="teammbrs_cnt_name">
                  <Skeleton count={6} />
                </div>
              </div>
            </div>
          ) : eagleData?.length === 0 ? (
            <div className="no-data-div">
              <div className="no-data-div-image">
                <img src="/images/nodata-image.png" alt="No data" />
              </div>
              <p>{t("noDataFound")}</p>
            </div>
          ) : (
            <div className="row">
              {/* Active Status Section */}
              <div className="forver_content">
                <span className="key">{t("Active Status")}</span>
                <span className="value">
                  <div
                    style={{
                      height: "15px",
                      width: "15px",
                      border: "1px solid",
                      float: "right",
                      backgroundColor: eagleData?.userActive
                        ? "green"
                        : "transparent",
                    }}
                  />
                </span>
              </div>

              {/* Monthly Status Grid */}
              <div
                style={{
                  display: "flex",
                  gap: "30px",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                  padding: "10px",
                  width: "100%",
                }}
              >
                {eagleData.months.map((obj, key) => (
                  <div
                    key={key}
                    className="forver_month"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    {/* Status Indicator */}
                    <div
                      style={{
                        height: "20px",
                        width: "20px",
                        border: "1px solid green",
                        backgroundColor:
                          obj.activeStatus > 0 ? "green" : "transparent",
                      }}
                    />

                    {/* Month Label */}
                    <span style={{ fontSize: "12px" }}>
                      {obj?.monthName?.substring(0, 3)}
                    </span>
                  </div>
                ))}
              </div>
              <div
                className="row forever_table"
                style={{
                  padding: "15px",
                  justifyItems: "center",
                  width: "100%",
                }}
              >
                <table className="table">
                  <thead>
                    <tr>
  
                
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>{t("Total KC")}</th>
                      <td>{t("You have")}: {parseFloat(eagleData?.summary?.totalPv || 0).toFixed(3)} KC</td>
                      <td>
                        <ProgressBar 
                          now={eagleData?.summary ? parseFloat(eagleData?.summary?.totalPv) : 0} 
                          label={`${parseFloat(eagleData?.summary?.totalPv || 0).toFixed(3)} / ${eagleData?.config?.total_cc || 0}`} 
                          variant="success" 
                          max={eagleData?.config?.total_cc || 100}
                          style={{ minHeight: '25px', fontSize: '12px' }}
                        />
                        <p> {eagleData?.config?.total_cc} ({t("Required")})</p>
                      </td>
                    </tr>
                    <tr>
                      <th>{t("New KC")}</th>
                      <td>{t("You have")}: {parseFloat(eagleData?.summary?.totalNewCC || 0).toFixed(3)} KC</td>
                      <td>
                        <ProgressBar 
                          now={eagleData?.summary ? parseFloat(eagleData?.summary?.totalNewCC) : 0} 
                          label={`${parseFloat(eagleData?.summary?.totalNewCC || 0).toFixed(3)} / ${eagleData?.config?.new_cc || 0}`} 
                          variant="success" 
                          max={eagleData?.config?.new_cc || 100}
                          style={{ minHeight: '25px', fontSize: '12px' }}
                        />
                        <p> {eagleData?.config?.new_cc} ({t("Required")})</p>
                      </td>
                    </tr>
                     <tr>
                      <th>{t("New Supervisors")}</th>
                      <td>                
                         <span
                        onClick={
                          eagleData?.summary?.superVisors?.count > 0
                            ? handleSupervisorClick
                            : undefined
                        }
                        style={{
                          cursor:
                            eagleData?.summary?.superVisors?.count > 0
                              ? "pointer"
                              : "default",
                          color:
                            eagleData?.summary?.superVisors?.count > 0
                              ? "#007bff"
                              : "#333",
                          textDecoration:
                            eagleData?.summary?.superVisors?.count > 0
                              ? "underline"
                              : "none",
                          position: "relative",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          transition: "background-color 0.2s",
                        }}
                        onMouseEnter={
                          eagleData?.summary?.superVisors?.count > 0
                            ? (e) => {
                                e.target.style.backgroundColor = "#f8f9fa";
                              }
                            : undefined
                        }
                        onMouseLeave={
                          eagleData?.summary?.superVisors?.count > 0
                            ? (e) => {
                                e.target.style.backgroundColor = "transparent";
                              }
                            : undefined
                        }
                      >
                       {t("You have")}: {eagleData?.summary?.superVisors?.count} {t("Supervisors")}
                      </span>
                      
                       </td>
                      <td> {eagleData?.config?.supervisor_lines} {t("Required")}</td>
                    </tr>
              
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
      {console.log("Eagle Data:", eagleData)}

        <Modal
              show={showSupervisorModal}
              onHide={closeSupervisorModal}
              size="lg"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <i className="fa fa-users me-2"></i>
                  Supervisor Details ({eagleData?.summary?.superVisors?.count || 0} Total)
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {eagleData?.summary?.superVisors && eagleData?.summary?.superVisors?.rows?.length > 0 ? (
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Username</th>
                        <th>Name</th>
                        <th>Join Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {eagleData?.summary?.superVisors?.rows?.map(
                        (supervisor, index) => (
                          <tr key={supervisor.id || index}>
                            <td>{index + 1}</td>
                            <td>{supervisor.username || "N/A"}</td>
                            <td>
                              <strong>
                                {supervisor.UserDetail?.name +
                                  " " +
                                  supervisor.UserDetail?.secondName}
                              </strong>
                            </td>
                            {/* <td>
                            <span className="badge bg-primary">
                              {supervisor.rank || "Supervisor"}
                            </span>
                          </td>
                          <td>
                            <span className="text-success">
                              {supervisor.totalPV?.toFixed(2) || "0.00"} PV
                            </span>
                          </td> */}
                            <td>{formatDate(supervisor.dateOfJoining) || "N/A"}</td>
                            <td>
                              <span
                                className={`badge ${
                                  supervisor.active ? "bg-success" : "bg-warning"
                                }`}
                              >
                                {supervisor.active ? "Active" : "Inactive"}
                              </span>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                ) : (
                  <div className="text-center py-4">
                    <i className="fa fa-users fa-3x text-muted mb-3"></i>
                    <p className="text-muted">No supervisor details available</p>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <div className="d-flex justify-content-between w-100">
                  <div>
                    <small className="text-muted">
                      Total Supervisors:{" "}
                      <strong>{eagleData?.summary?.superVisors?.count || 0}</strong> |
                      Required:{" "}
                      <strong>{eagleData?.config?.supervisor_lines || 0}</strong>
                    </small>
                  </div>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeSupervisorModal}
                  >
                    Close
                  </button>
                </div>
              </Modal.Footer>
            </Modal>
    </div>
    
  );
};

export default EagleManager;
